import { Component, Watch, Vue } from 'vue-property-decorator';

@Component
export default class Sidebar extends Vue {
    private currentMenu = ''
    mounted() {
        this.currentMenuInfo()
    }

    @Watch('$route')
    onRouteChante() {
        this.currentMenuInfo()
    }

    currentMenuInfo() {
        const path = ( this.$router as any ).history.current.path
        const pathList = path.split('/')
        this.currentMenu = pathList[2]
    }
  

}